import { defineStore } from 'pinia'
import i18n from '../locales'

const STORAGE_KEY = 'app_locale'
const SUPPORTED = ['en', 'zh-CN']

export const useLocaleStore = defineStore('locale', {
  state: () => ({ currentLocale: 'en' }),
  actions: {
    setLocale(locale) {
      if (!SUPPORTED.includes(locale)) return
      this.currentLocale = locale
      i18n.global.locale.value = locale
      if (typeof document !== 'undefined') {
        document.documentElement.lang = locale === 'zh-CN' ? 'zh-CN' : 'en'
      }
      try {
        localStorage.setItem(STORAGE_KEY, locale)
      } catch (_) {}
    },
    initFromStorage() {
      try {
        const saved = localStorage.getItem(STORAGE_KEY)
        if (saved === 'zh-CN' || saved === 'en') {
          this.setLocale(saved)
          return true
        }
      } catch (_) {}
      return false
    },
    initFromBrowser() {
      if (typeof navigator === 'undefined') return
      const lang = (navigator.language || navigator.userLanguage || '').toLowerCase()
      if (lang.startsWith('zh')) this.setLocale('zh-CN')
    },
    init() {
      if (!this.initFromStorage()) this.initFromBrowser()
    }
  }
})
